import React from "react";
import styled from "styled-components";
import { DeviceSize } from "./deviceSize";
import appleMusicImage from "./appleMusicImage.webp";
import spotifyImage from "./spotifyImage.webp";
import youtubeImage from "./youtubeImage.webp";
import instagramImage from "./instagramImage.webp";
import tiktokImage from "./tiktokImage.webp";

export const SocialNetworks: React.FC = () => (
  <Container>
    <SocialNetwork src={appleMusicImage} alt="apple-music" />
    <SocialNetwork src={spotifyImage} alt="spotify" />
    <SocialNetwork src={youtubeImage} alt="youtube" />
    <SocialNetwork src={instagramImage} alt="instagram" />
    <SocialNetwork src={tiktokImage} alt="tik-tok" />
  </Container>
);

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  background-color: rgba(255, 255, 255, 0.66);
  border-radius: 15px;
  padding: 20px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  gap: 15px;
  @media (max-width: ${DeviceSize.MobileMax}) {
    display: none;
  }
`;

const SocialNetwork = styled.img`
  height: 40px;
  @media (max-width: ${DeviceSize.TabletMax}) {
    height: 22px;
  }
`;
